import { render, staticRenderFns } from "./CartItemList.vue?vue&type=template&id=8c0fbf74"
import script from "./CartItemList.vue?vue&type=script&lang=js"
export * from "./CartItemList.vue?vue&type=script&lang=js"
import style0 from "./CartItemList.vue?vue&type=style&index=0&id=8c0fbf74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports